// Module
var code = `<div class="access-field">
    <div class="access-field-bit-range">
        <a href class="access-field-bit-range-link">[<span class="access-field-bits-offset">Off</span>..<span class="access-field-bits-end">End</span>]</a>
    </div>
    <div class="access-field-name">
        <a href class="access-field-struct-name">struct_name</a> <span class="access-field-full-name">field</span>
        <br/>(<span class="access-field-type">type</span>)
    </div>
    <div class="access-field-calls-metadata">
        <span class="access-field-calls-size">0</span> accesses
    </div>
</div>
<div class="access-calls"></div>`;
// Exports
export default code;